export default __webpack_public_path__ + "static/media/historyBanner.612b7e11.jpg";